import React, { ReactNode } from 'react';

import { Tooltip } from '@mui/material';
import { IconButton } from '@infoods/lifebase-ui';

import classes from './OptionButton.module.scss';

type OptionButtonProps = {
  tooltipText: string;
  onClick: () => void;
  icon: ReactNode;
};

const OptionButton = ({ tooltipText, onClick, icon }: OptionButtonProps) => {
  return (
    <Tooltip title={tooltipText}>
      <IconButton className={classes.iconBtn} onClick={onClick}>
        {icon}
      </IconButton>
    </Tooltip>
  );
};

export { OptionButton };
